// utils/pedidosSearchParams.js — buscar-historial (28-sep-2026). LA regla del buscador de
// Pedidos, en un solo lugar y testeable:
//   · SIN texto: la lista es la ventana rápida (últimas 2 semanas por defecto) — viajan
//     after/before del rango elegido.
//   · CON texto: la búsqueda va a TODO el historial del espejo — el período se IGNORA (no se
//     mandan after/before), porque el pedido que se busca suele ser justo el que quedó fuera
//     de la ventana. El backend (pedirPedidosEspejo) resuelve la consulta histórica en Mongo.
//   · El estado se respeta siempre (viaja al server); canal y método de pago filtran en el
//     cliente sobre lo que llega, así que también se respetan.
export function paramsListaPedidos({ perPage, page, status, rango, search }) {
  const params = new URLSearchParams({ per_page: perPage, page });
  if (status) params.set('status', status);
  const texto = String(search || '').trim();
  if (texto) {
    params.set('search', texto);
  } else {
    if (rango && rango.from) params.set('after', `${rango.from}T00:00:00-05:00`);
    if (rango && rango.to) params.set('before', `${rango.to}T23:59:59-05:00`);
  }
  return params;
}
